<template>
  <div
      class="ticket-simple"
      :callCount="item.callCount"
      :class="customClass"
  >
    <div class="ticket-simple__wrapper">
      <div class="ticket-simple__number">
        <div class="ticket-simple__number-item">
          <span>{{ item.ticketNumber }}</span>
        </div>
      </div>

      <div class="ticket-simple__arrow">
        <IconArrowRightItalic />
      </div>

      <div class="ticket-simple__window">
        <div class="ticket-simple__window-item">
          <template v-if="$scopedSlots.seatLabel">
            <slot name="seatLabel" :item="item" />
          </template>
          <template v-else>
            <span>{{ item.seatLabel }}</span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// components
import { mapState } from 'vuex'
import IconArrowRightItalic from '@/components/Icons/IconArrowRightItalic.vue'

export default {
  name: 'TicketSimple',
  components: {
    IconArrowRightItalic
  },
  props: {
    item: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapState({
      playListSpeakId: state => state.playlist.speakId
    }),
    customClass () {
      return {
        [`ticket-simple--state_${this.item.screenStateId}`]: this.item.screenStateId
      }
    }
  }
}
</script>

<style lang="stylus">

.ticket-simple {
  display flex
  font-size 60px

  &__wrapper {
    display flex
    flex-direction row
    justify-content space-between
    align-items center
    flex 1
  }

  &__number {
    flex 1
    display flex
    justify-content flex-start
    box-sizing border-box

    &-item {
      display flex
      justify-content center
      align-items center
      span {
        height 1em
        font-size 1em
        line-height normal
      }
    }
  }
  &__arrow {
    svg {
      width 1.25em
      height 1.25em
    }
  }
  &__window {
    flex 1
    display flex
    justify-content flex-end
    box-sizing border-box

    &-item {
      display flex
      justify-content center
      align-items center
      height 2em
      aspect-ratio 1
      border-radius 32px

      span {
        height 1em
        font-size 1em
        line-height normal
      }
    }
  }
}

.ticket-simple--state {
  &_1 {
    .ticket-simple__window-item {
      background-color #F0ECEC
    }
  }

  &_3,
  &_5 {
    opacity 0.4
    .ticket-simple__window-item {
      background-color #F0ECEC
    }
  }

  &_2,
  &_4 {
    .ticket-simple__window-item {
      background-color var(--color-highlighty)
    }
  }
}

// Адаптив ----------------------------------------------------------------------------------------------------- Адаптив
.flex-table-queue--horizontal {
  .ticket-simple {
    &__arrow {
      display none
    }

    &__window {
      &-item {
        height 1em
        background-color transparent
      }
    }
  }
}

</style>
